import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { required } from "../../../util/validators";
import { ImportModal } from "../../components/ImportModal";

export const ImportLabNotesModal = ({ onImport, labId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      labId: values.labId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/lab_notes/import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Add Lab Notes from CSV..."
      initialValues={{ labId }}
      exampleDownloadPath="/admin/lab_notes/example"
    >
      {(formProps) => <Field component={TextInput} name="labId" type="hidden" required validate={required} />}
    </ImportModal>
  );
};
